<p-fieldset legend="Arquivos do Ajuste">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item" *ngIf="tipoAjuste === 'AJUSTE_CONTRATO'">
      <a class="nav-link" id="termo-aditivo-tab" data-toggle="tab" href="#termo-aditivo" role="tab"
        aria-controls="termo-aditivo" aria-selected="true">Termos Aditivos</a>
    </li>
    <li class="nav-item" *ngIf="tipoObjeto === 'ENGENHARIA'">
      <a class="nav-link" id="exigencia-obras-tab" data-toggle="tab" href="#exigencia-obras" role="tab"
        aria-controls="exigencia-obras" aria-selected="true">Exigências de Obras</a>
    </li>
    <li class="nav-item">
      <a class="nav-link active" id="execucao-tab" data-toggle="tab" href="#execucao" role="tab"
        aria-controls="execucao" aria-selected="true">Execuções</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="empenho-tab" data-toggle="tab" href="#empenho" role="tab" aria-controls="empenho"
        aria-selected="true">Empenhos</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="documento-fiscal-tab" data-toggle="tab" href="#documento-fiscal" role="tab"
        aria-controls="documento-fiscal" aria-selected="true">Documentos Fiscais</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="pagamento-tab" data-toggle="tab" href="#pagamento" role="tab" aria-controls="pagamento"
        aria-selected="true">Pagamentos</a>
    </li>
  </ul>
  <div class="tab-content pt-3">
    <div class="tab-pane fade" id="termo-aditivo" role="tabpanel" aria-labelledby="termo-aditivo-tab"
      *ngIf="tipoAjuste === 'AJUSTE_CONTRATO'">
      <lib-licitacao-audesp-termo-aditivo-list [licitacao]="licitacao" [registroPreco]="registroPreco"
        [ajuste]="ajuste"></lib-licitacao-audesp-termo-aditivo-list>
    </div>
    <div class="tab-pane fade" id="exigencia-obras" role="tabpanel" aria-labelledby="exigencia-obras-tab"
      *ngIf="tipoObjeto === 'ENGENHARIA'">
      <lib-licitacao-audesp-exigencia-obras-list [licitacao]="licitacao" [registroPreco]="registroPreco"
        [ajuste]="ajuste"></lib-licitacao-audesp-exigencia-obras-list>
    </div>
    <div class="tab-pane fade show active" id="execucao" role="tabpanel" aria-labelledby="execucao-tab">
      <lib-licitacao-audesp-execucao-list [licitacao]="licitacao" [registroPreco]="registroPreco" [ajuste]="ajuste">
      </lib-licitacao-audesp-execucao-list>
    </div>
    <div class="tab-pane fade" id="empenho" role="tabpanel" aria-labelledby="empenho-tab">
      <lib-licitacao-audesp-empenho-list [licitacao]="licitacao" [registroPreco]="registroPreco" [ajuste]="ajuste">
      </lib-licitacao-audesp-empenho-list>
    </div>
    <div class="tab-pane fade" id="documento-fiscal" role="tabpanel" aria-labelledby="documento-fiscal-tab">
      <lib-licitacao-audesp-documento-fiscal-list [licitacao]="licitacao" [registroPreco]="registroPreco"
        [ajuste]="ajuste"></lib-licitacao-audesp-documento-fiscal-list>
    </div>
    <div class="tab-pane fade" id="pagamento" role="tabpanel" aria-labelledby="pagamento-tab">
      <lib-licitacao-audesp-pagamento-list [licitacao]="licitacao" [registroPreco]="registroPreco" [ajuste]="ajuste">
      </lib-licitacao-audesp-pagamento-list>
    </div>
  </div>
</p-fieldset>